/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AuditLogDocumentSortCriteria {
    getFixupPrototypeFunction() { return AuditLogDocumentSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<AuditLogDocumentSortCriteria>): AuditLogDocumentSortCriteria {
        let obj = Object.assign(new AuditLogDocumentSortCriteria(), model);
        AuditLogDocumentSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AuditLogDocumentSortCriteria>): AuditLogDocumentSortCriteria {
        if (!model) return null;
        return AuditLogDocumentSortCriteria.newInstance(<AuditLogDocumentSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AuditLogDocumentSortCriteria) {
        if (!obj) return;

        models.AuditLogDocumentSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AuditLogDocumentSortCriteria): boolean {
        Object.setPrototypeOf(obj, AuditLogDocumentSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.AuditLogDocumentSortColumn;

    ascending: boolean;

}
